import MasterDataComponent from "../components/MasterData";
import useMasterData from "../hooks/useMasterData";
import useOptions from "../hooks/useOptions";

const MasterData = () => {
  const MasterDataProps = useOptions();
  const MasterDatatMainProps = useMasterData();
  return <MasterDataComponent {...MasterDataProps} {...MasterDatatMainProps} />;
};

export default MasterData;
